"use client";

import { createGlobalStyle } from "styled-components";

import { CompressedDefaultFonts } from "./FaireFontStyle";

/**
 * Global style defining Faire's fonts (for Typography).
 */
export const FontStyle = createGlobalStyle`
  ${CompressedDefaultFonts}
`;
